/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileBase_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
    readonly " $refType": "ItemTileBase_viewer";
};
export type ItemTileBase_viewer$data = ItemTileBase_viewer;
export type ItemTileBase_viewer$key = {
    readonly " $data"?: ItemTileBase_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTileBase_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Shipping_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '3a2dc2c77f4d0f70ab043a085994c1de';
export default node;
